import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import client from "@culturehq/client";
import { Loader } from "@culturehq/components";

class InboundLink extends Component {
  constructor(props) {
    super(props);

    const { match, location } = props;
    const { token } = match.params;

    // Target URL & Query Params
    const target = match.params[0] || "";
    this.target = `/${target}${location.search}${location.hash}`;

    if (token === "culturehq") {
      this.state = { redirectTo: this.target };
    } else {
      this.state = { redirectTo: null };
      this.checkToken(token);
    }
  }

  async checkToken(token) {
    let redirectTo = "/";

    try {
      await client.getInvite({ token });

      // Invite is valid. Redirect the user to
      // the /accept route to create their account.
      redirectTo = `/accept/${token}${this.target}`;
    } catch (err) {
      // Invite is invalid. This could mean:
      //   a.) Invite has already been claimed.
      //   b.) Invite code is invalid.
      // Either way, redirect the user
      // to the requested target URL.
      redirectTo = this.target;
    }

    this.setState({ redirectTo });
  }

  render() {
    const { redirectTo } = this.state;

    if (redirectTo) {
      return <Redirect to={redirectTo} />;
    }

    return <Loader loading />;
  }
}

export default InboundLink;
